import { useMutation } from "react-query";
import { getPendingInvoiceById } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetPendingInvoiceById = () => {
  return useMutation(getPendingInvoiceById);
};
